import { CopyOutlined } from "@ant-design/icons";
import { Button } from "antd";

type Props = {
  userWalletAddress: string;
  onClickCopy: () => void;
};

export const AddressCopyButton = (props: Props) => {
  return (
    <Button
      icon={<CopyOutlined style={{ height: "14px", width: "14px" }} />}
      style={{
        color: "var(--Geek-Blue-6, #2F54EB)",
        borderColor: "#597ef7",
        fontSize: "16px",
        lineHeight: "26px",
        height: "fit-content",
        boxSizing: "border-box",
      }}
      onClick={props.onClickCopy}
    >
      {props.userWalletAddress}
    </Button>
  );
};
